import React, { useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { isAuthenticated } from "../../../Utils/Auth";
import jwtDecode from "jwt-decode";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      width: "100%",
      height: "60px",
    },
  },
}));

const ColorButton = withStyles((theme) => ({
  root: {
    color: "#fff",
    borderRadius: "0px",
    boxShadow: "0px 4px 12px rgba(var(--primColor), 20%)",
    backgroundColor: "var(--primColor)",
    border: "1px solid var(--primColor)",
    transition: "200ms all ease-in-out",
    fontSize: "16px",
    height: "48px",

    "&:hover": {
      backgroundColor: "var(--secColor)",
      color: "#000",
      border: "1px solid var(--primColor)",
      opacity: "0.9",
      boxShadow: "0px 4px 12px rgba(var(--primColor), 20%)",
    },
  },
}))(Button);

const PrimaryButton = (props) => {
  const classes = useStyles();
  const { admin, isemp } = isAuthenticated()
    ? jwtDecode(isAuthenticated())
    : {};
  return (
    <div
      className={`${classes.root} ${props.btnSize} ${props.class} primButton`}
    >
      <ColorButton
        variant="contained"
        color="primary"
        id={props.id}
        disabled={
          parseInt(admin) == 1 &&
          parseInt(isemp) == 1 &&
          props.dont_need_disable != "need"
            ? true
            : props.disabled
        }
        onClick={props.onClick}
        type={props.type}
      >
        {props.iconLeft}
        {props.label}
        {props.children}
      </ColorButton>
    </div>
  );
};

export default PrimaryButton;
